import { RowCellContent, Table, TableBody } from "@dash/table";
import { MdCheck, MdClose } from "react-icons/md";

import { DocExchangeStatus } from "@megaron/docs-contracts";

type Props = {
  statuses: DocExchangeStatus[];
  isLoading: boolean;
};

export const DocExchangeStatusTable: React.FC<Props> = ({ statuses, isLoading }) => {
  const getTableRowCellsContent = (status: DocExchangeStatus): RowCellContent[] => [
    { element: status.docType },
    { element: status.exchange },
    { element: <Code>{status.hash}</Code> },
    { element: status.writerInitialized ? <MdCheck color="green" /> : <MdClose color="red" /> },
    {
      element: (
        <span title={status.writers.join(", ")}>{status.writers.length === 0 ? "—" : status.writers.join(", ")}</span>
      ),
    },
    { element: status.indexAliased ? <MdCheck color="green" /> : <MdClose color="red" /> },
    { element: formatSequence(status.readerCursor) },
    { element: formatSequence(status.latestWriterSequence) },
    { element: formatSequence(status.readerLag) },
  ];

  return (
    <div css={{ overflow: "auto", margin: "0 -2rem 1rem", padding: "0 2rem" }}>
      <Table
        columns={[
          { label: "Document type" },
          { label: "Exchange" },
          { label: "Hash" },
          { label: "Writer initialized" },
          { label: "Writer" },
          { label: "Index aliased" },
          { label: "Reader cursor" },
          { label: "Latest writer sequence" },
          { label: "Reader lag" },
        ]}
      >
        <TableBody
          isLoading={isLoading}
          rows={statuses.map((status) => ({
            uuid: `${status.docType}-${status.exchange}`,
            cellsContent: getTableRowCellsContent(status),
          }))}
        />
      </Table>
    </div>
  );
};

const Code: React.FC<{ children: string }> = ({ children }) => (
  <code css={{ fontSize: "0.75rem", whiteSpace: "nowrap" }}>{children}</code>
);

const formatSequence = (sequence: number | null) => (sequence === null ? "—" : sequence.toLocaleString());
